// Copyright (c) StrangeBee 2023

import { PlatformStatusController } from 'thehive-sdk';

export interface PlatformStatusEventList {
    onReindex: (indexName: string) => Promise<void>;
    onTrigger: (entityName: string) => Promise<void>;
    onRebuild: (indexName: string) => Promise<void>;
    onGlobalTrigger: (entityName: string) => Promise<void>;
    onDedupTrigger: (entityName: string) => Promise<void>;
}

interface PlatformStatusEventListParams {
    locale: (label: string, params: any) => string;
    controller: PlatformStatusController;
    onSuccess: (count?: boolean, message?: string) => void;
    onError: (label?: string) => void;
}

export const computeEventList = ({
    controller,
    locale,
    onError,
    onSuccess,
}: PlatformStatusEventListParams): PlatformStatusEventList => ({
    onReindex: (indexName) =>
        controller
            .reindex(indexName)
            .then(() => onSuccess(false, locale('platform.index.actions.reindex.success', { indexName })))
            .catch(onError),
    onTrigger: (entityName) =>
        controller
            .trigger(entityName)
            .then(() => onSuccess(false, locale('platform.check.actions.trigger.success', { entityName })))
            .catch(onError),
    onGlobalTrigger: (entityName) =>
        controller
            .global(entityName)
            .then(() => onSuccess(false, locale('platform.check.actions.global.success', { entityName })))
            .catch(onError),
    onDedupTrigger: (entityName) =>
        controller
            .dedup(entityName)
            .then(() => onSuccess(false, locale('platform.check.actions.dedup.success', { entityName })))
            .catch(onError),
    onRebuild: (indexName) => controller.rebuild(indexName).catch(onError),
});
